import Image from 'next/image';
import { RichText } from 'prismic-reactjs';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import PartnersBG from './assets/integrations-partners-bg.png';

const SectionWrapper = styled.section`
  ${fluidProp('padding-top', '80px', '160px')}
  ${fluidProp('padding-bottom', '80px', '100px')}
  position: relative;
  background-image: url(${PartnersBG.src});
  background-size: cover;
`;

const LogosWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 30px;
  align-items: flex-start;
`;

const Illustration = styled.div`
  padding: 20px 44px 0 44px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ComingSoonWrapper = styled.div`
  padding: 5px 22px;
  background: var(--colors-turquoise);
  ${({ theme }) => theme.typography.subHeadSM}
  text-transform: uppercase;
  border-radius: 17px;
  text-align: center;
  margin-top: 20px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

const Title = styled.div`
  ${({ theme }) => theme.typography.scale3}
  ${fluidProp(['font-size'], '24px', '42px')}
  color: var(--colors-blank);
  max-width: 578px;
  margin: 0 auto;
  text-align: center;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const PartnersSection = ({ title, logos }) => (
  <SectionWrapper>
    <ContentContainer>
      {title && <RichText render={title} Component={Title} />}
      <LogosWrapper>
        {logos.map((item, index) => (
          <Illustration key={index}>
            <Image
              src={item.logo.url}
              alt={item.logo.alt}
              width={item.logo.dimensions.width}
              height={item.logo.dimensions.height}
              quality="100"
            />
            {item.coming_soon && <ComingSoonWrapper>Coming soon</ComingSoonWrapper>}
          </Illustration>
        ))}
      </LogosWrapper>
    </ContentContainer>
  </SectionWrapper>
);
